{
  "oneUpgrade": {
    "errors": {
      "ticketNotIssued": {
        "heading": "Upgrades not available yet",
        "paragraph": "We're still issuing your tickets. Check upgrade availability once you've received them by email."
      }
    }
  },
  "ondMarketing": {
    "breadcrumb": {
      "flights": "Flights",
      "fromCity": "From cities",
      "cityToCity": "City to city",
      "fromCountry": "From countries",
      "countryToCountry": "Country to country"
    },
    "heading": {
      "flights": "Discover our flights and routes",
      "fromCity": "Flights from cities",
      "cityToCity": "Explore more flights and destinations",
      "fromCountry": "Flights from countries",
      "countryToCountry": "Explore more flights and destinations"
    },
    "flightsFrom": "Flights from {origin}",
    "destinationFlightInfo": {
      "startingFrom": "Starting from",
      "roundTrip": "Round trip",
      "oneWay": "One way",
      "flightTime": "Flight time",
      "approx": "Approx.",
      "airports": "Airports",
      "directFlights": "Direct flights",
      "frequency": {
        "unit": {
          "day": "/ day",
          "week": "/ week"
        },
        "perDay": {
          "singular": "1 flight / day",
          "plural": "{count} flights / day"
        },
        "perWeek": {
          "singular": "1 flight / week",
          "plural": "{count} flights / week"
        }
      }
    },
    "destinationPromotion": {
      "title": "Discover {destination}",
      "description": {
        "direct": "Finnair offers direct flights from {origin} to {destination} with {frequency}. The flight takes approximately {duration}.",
        "connecting": "Finnair offers flights from {origin} to {destination} with a convenient connection in Helsinki. The journey takes approximately {duration}.",
        "basic": "Book flights from {origin} to {destination} and discover what the city has to offer.",
        "destinationPage": " Curious about {destination}? Find tips and ideas for your trip."
      },
      "frequency": {
        "perDay": {
          "singular": "1 flight a day",
          "plural": "{count} flights a day"
        },
        "perWeek": {
          "singular": "1 flight a week",
          "plural": "{count} flights a week"
        }
      }
    },
    "fromTo": "{origin}–{destination}"
  }
}
